enum QuickQuoteReplyActionMode {
  DraftPrimary = 'draft_primary',
  SendPrimary = 'send_primary',
  SendOnly = 'send_only',
}

export default QuickQuoteReplyActionMode;
